var path = 'areas/projects/action-template-fields/field-Certificate.html';
var html = "<div> <div ng-if=vm.project> <certificate-variable-select model=vm.value project=vm.project></certificate-variable-select> </div> <div ng-if=!vm.project> <certificate-select on-change=vm.certificateSelected selected-id=vm.value tenant-id=vm.tenantId></certificate-select> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/action-template-fields/field-Certificate.html
// module id = 7695808451103786
// module chunks = 1